import { call, put, all, takeEvery, takeLatest } from "redux-saga/effects";
import * as api from "constants/api";


import {
    // UPDATE_GPT_RESPONSE_SCORE_PAGE_NUMBER,
    GET_GPT_RESPONSE_SCORE_PENDING,
    GET_GPT_RESPONSE_SCORES,
    SG_GET_GPT_RESPONSE_SCORES,
    DELETE_GPT_RESPONSE_SCORE,
    SG_DELETE_GPT_RESPONSE_SCORE,
    FETCH_GPT_RESPONSE_SCORE,
    SG_FETCH_GPT_RESPONSE_SCORE,
    EDIT_GPT_RESPONSE_SCORE,
    SG_EDIT_GPT_RESPONSE_SCORE,
    ADD_GPT_RESPONSE_SCORE,
    SG_ADD_GPT_RESPONSE_SCORE,
    // CLEAR_GPT_RESPONSE_SCORE,
    ALL_ERRORS,
} from "constants/actions";
import { handleError } from "./ApiError";

function* loadmethods(action) {
    yield put({ type: GET_GPT_RESPONSE_SCORE_PENDING });
  // console.log('action.payload', action.payload)
  try {
    const json = yield call(api.GET_GPT_RESPONSE_SCORES, action.payload);
    // console.log(json.data)
    yield put({ type: GET_GPT_RESPONSE_SCORES, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodLoad() {
  yield takeEvery(SG_GET_GPT_RESPONSE_SCORES, loadmethods);
}

function* fetchmethods(action) {
    yield put({ type: GET_GPT_RESPONSE_SCORE_PENDING });
  try {
    const json = yield call(api.FETCH_GPT_RESPONSE_SCORE, action.payload);
    yield put({ type: FETCH_GPT_RESPONSE_SCORE, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodFetch() {
  yield takeLatest(SG_FETCH_GPT_RESPONSE_SCORE, fetchmethods);
}

function* updatemethods(action) {
  try {
    const json = yield call(api.EDIT_GPT_RESPONSE_SCORE, action.payload);
    yield put({ type: EDIT_GPT_RESPONSE_SCORE, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodUpdate() {
  yield takeLatest(SG_EDIT_GPT_RESPONSE_SCORE, updatemethods);
}

function* addmethods(action) {
  // RESET_ADD_ACTIVE_PAGE_GPT_RESPONSE_SCORE
  try {
    const json = yield call(api.ADD_GPT_RESPONSE_SCORE, action.payload);
    yield put({ type: ADD_GPT_RESPONSE_SCORE, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodAdd() {
  yield takeLatest(SG_ADD_GPT_RESPONSE_SCORE, addmethods);
}

function* deletemethods(action) {
  try {
    yield call(api.DELETE_GPT_RESPONSE_SCORE, action.payload);
    yield put({ type: DELETE_GPT_RESPONSE_SCORE, payload: action.payload });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodDelete() {
  yield takeLatest(SG_DELETE_GPT_RESPONSE_SCORE, deletemethods);
}


export default function* index() {
  yield all([
    methodLoad(),
    methodFetch(),
    methodUpdate(),
    methodAdd(),
    methodDelete(),
  ]);
}
